import { Injectable } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AppInsightsService {
  private appInsights: ApplicationInsights;
  constructor() {
    this.appInsights = new ApplicationInsights({
      config: {
        instrumentationKey: environment.appinsights_instrumentationkey,
        enableAutoRouteTracking: true, // Optional: tracks page views automatically
      }
    });
    this.appInsights.loadAppInsights();
  }

  // Log custom event
  logEvent(eventName: string, properties?: { [key: string]: any }) {
    this.appInsights.trackEvent({ name: eventName }, properties);
  }

  // Log errors
  logError(error: Error, properties?: { [key: string]: any }) {
    this.appInsights.trackException({ exception: error }, properties);
  }

  // Log page views
  logPageView(pageName?: string, url?: string) {
    this.appInsights.trackPageView({ name: pageName, uri: url });
  }
  logTrace(message: string, properties?: { [key: string]: any }) {
    this.appInsights.trackTrace({ message }, properties);
  }
  logMetric(name: string, average: number, properties?: { [key: string]: any }) {
    this.appInsights.trackMetric({ name, average }, properties);
  }
  setUser(userId: string) {
    this.appInsights.setAuthenticatedUserContext(userId);
  }
}

